import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { Modal, Button, Form, Badge, Card, Row, Col, Container, Spinner, ListGroup, Toast, ToastContainer, InputGroup, Table } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Select from 'react-select';
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import './dashboard.css';
import Foto from "../Components/Foto";
import logoSmall from './../../../public/Images/logo.png';
import logoF2 from '../../../public/Images/f2.png';

const chapaRH = localStorage.getItem("chapa");
const nomeRHLogado = localStorage.getItem("nome");
const fotoCache = new Map();

const carinhasMap = {
    1: { emoji: '😢', rotulo: 'Péssimo', cor: 'danger' },
    2: { emoji: '😟', rotulo: 'Ruim', cor: 'warning' },
    3: { emoji: '😐', rotulo: 'Neutro', cor: 'secondary' },
    4: { emoji: '🙂', rotulo: 'Bom', cor: 'info' },
    5: { emoji: '😁', rotulo: 'Excelente', cor: 'success' }
};

const getData10DiasAtras = () => {
    const data = new Date();
    data.setDate(data.getDate() - 10);
    return data.toISOString().slice(0, 10);
};

const formatarDataHora = (isoString) => {
    if (!isoString) return "";
    const data = isoString.replace("Z", "");
    const dt = new Date(data);
    const dia = String(dt.getDate()).padStart(2, "0");
    const mes = String(dt.getMonth() + 1).padStart(2, "0");
    const ano = dt.getFullYear();
    const hora = String(dt.getHours()).padStart(2, "0");
    const minuto = String(dt.getMinutes()).padStart(2, "0");
    const segundo = String(dt.getSeconds()).padStart(2, "0");

    return `${dia}/${mes}/${ano}, ${hora}:${minuto}:${segundo}`;
};

// Componente isolado para renderizar avatar com foto em background sem afetar o estado pai
const FotoFuncionarioAvatar = React.memo(({ chapa, nome, info01, info02, onSelectFoto, styleCustom }) => {
    const [fotoSrc, setFotoSrc] = useState(null);

    useEffect(() => {
        if (!chapa) return;
        let isMounted = true;
        const hoje = new Date().toISOString().slice(0, 10);
        const chave = `func_${chapa}_${hoje}`;

        if (fotoCache.has(chave)) {
            setFotoSrc(fotoCache.get(chave));
            return;
        }

        api.get(`/usuario/foto/${chapa}`)
            .then(res => {
                if (isMounted && res?.data?.foto) {
                    fotoCache.set(chave, res.data.foto);
                    setFotoSrc(res.data.foto);
                }
            })
            .catch(() => { });

        return () => { isMounted = false; };
    }, [chapa]);

    const handleClick = (e) => {
        if (e) e.stopPropagation();
        if (fotoSrc && onSelectFoto) {
            onSelectFoto({
                foto: `data:image/jpeg;base64,${fotoSrc}`,
                nome: nome || "",
                info01: info01 || `Matrícula: ${chapa}`,
                info02: info02 || ""
            });
        }
    };

    return (
        <div
            className="foto-avatar-list"
            onClick={handleClick}
            style={styleCustom || {}}
        >
            {fotoSrc ? (
                <img
                    src={`data:image/jpeg;base64,${fotoSrc}`}
                    alt="foto"
                    style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                />
            ) : (
                <span>👤</span>
            )}
        </div>
    );
});

const handleImprimirModal = () => {
    const modalElemento = document.querySelector('#modal-solicitacao-vaga .modal-body');
    if (!modalElemento) {
        Swal.fire('Aviso', 'Conteúdo da solicitação não encontrado.', 'warning');
        return;
    }

    const modalClonado = modalElemento.cloneNode(true);
    modalClonado.querySelectorAll('img').forEach(img => {
        img.src = img.src;
    });

    const conteudoModal = modalClonado.innerHTML;

    const htmlCompleto = `
        <!DOCTYPE html>
        <html lang="pt-br">
            <head>
                <meta charset="UTF-8">
                <title>Impressão - Solicitação de Vaga</title>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
                <style>
                    @page { size: A4 landscape; margin: 4mm !important; }
                    html, body { background: #fff !important; margin: 0 !important; padding: 0 !important; width: 100% !important; height: auto !important; overflow: visible !important; font-family: system-ui, -apple-system, sans-serif !important; }
                    .no-print, .btn-close, button, .modal-footer, script { display: none !important; }
                    .row { display: flex !important; flex-wrap: wrap !important; margin-right: -4px !important; margin-left: -4px !important; }
                    .col-md-2 { width: 16.666667% !important; flex: 0 0 16.666667% !important; max-width: 16.666667% !important; }
                    .col-md-3 { width: 25% !important; flex: 0 0 25% !important; max-width: 25% !important; }
                    .col-md-4 { width: 33.333333% !important; flex: 0 0 33.333333% !important; max-width: 33.333333% !important; }
                    .col-md-5 { width: 41.666667% !important; flex: 0 0 41.666667% !important; max-width: 41.666667% !important; }
                    .col-md-6 { width: 50% !important; flex: 0 0 50% !important; max-width: 50% !important; }
                    .col-md-12 { width: 100% !important; flex: 0 0 100% !important; max-width: 100% !important; }
                    .card { border: 1px solid #aaa !important; margin-bottom: 4px !important; padding: 6px !important; box-shadow: none !important; background-color: #f8f9fa !important; }
                    fieldset { padding: 4px !important; margin: 0 !important; border: 1px solid #ccc !important; }
                    .form-control, textarea.form-control { font-size: 9.5px !important; padding: 1px 4px !important; height: 22px !important; min-height: 22px !important; background-color: #fff !important; color: #000 !important; border: 1px solid #bbb !important; }
                    textarea.form-control { height: auto !important; min-height: 28px !important; }
                    .form-label, label { font-size: 8px !important; margin-bottom: 1px !important; font-weight: bold !important; }
                    .campo-funcionario, .legenda-funcionario { background-color: #e9ecef !important; border: 1px solid #ced4da !important; color: #212529 !important; }
                    .campo-parttime, .legenda-parttime { background-color: #ced4da !important; border: 1px solid #adb5bd !important; color: #111827 !important; }
                    .rodape-impressao { display: flex !important; justify-content: space-between !important; align-items: flex-end !important; margin-top: 6px !important; padding-top: 2px !important; }
                    .rodape-impressao img { display: block !important; max-height: 38px !important; width: auto !important; }
                    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; page-break-inside: avoid !important; }
                </style>
            </head>
            <body>
                <div class="container-fluid p-0">${conteudoModal}</div>
            </body>
        </html>
    `;

    const blob = new Blob([htmlCompleto], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const janelaImpressao = window.open(url, '_blank');

    if (!janelaImpressao) {
        Swal.fire('Atenção', 'O navegador bloqueou a janela pop-up de impressão.', 'warning');
        return;
    }

    janelaImpressao.onload = () => {
        setTimeout(() => {
            janelaImpressao.print();
            janelaImpressao.close();
            URL.revokeObjectURL(url);
        }, 400);
    };
};

function DashboardRH() {
    const hojeISO = new Date().toISOString().slice(0, 10);

    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroStatus, setFiltroStatus] = useState("0");
    const [showAlerta, setShowAlerta] = useState(false);

    const [selected, setSelected] = useState(null);
    const [mensagens, setMensagens] = useState([]);
    const [showResponder, setShowResponder] = useState(false);
    const [respostaHtml, setRespostaHtml] = useState("");
    const [salvarFaq, setSalvarFaq] = useState(false);
    const [loadingChat, setLoadingChat] = useState(false);
    const [arquivoRH, setArquivoRH] = useState(null);

    // --- ESTADOS GESTÃO DE FAQ ---
    const [showModalFaq, setShowModalFaq] = useState(false);
    const [assuntosFaq, setAssuntosFaq] = useState([]);
    const [buscaFaq, setBuscaFaq] = useState("");
    const [faqId, setFaqId] = useState(0);
    const [faqPergunta, setFaqPergunta] = useState("");
    const [faqResposta, setFaqResposta] = useState("");
    const [faqAtivo, setFaqAtivo] = useState("S");
    const [modoFaq, setModoFaq] = useState("novo");

    const tituloRef = useRef(null);
    const qtdAnteriorRef = useRef(0);

    // --- ESTADOS NAVEGAÇÃO E MODOS ---
    const [viewMode, setViewMode] = useState("chamados");
    const [curriculos, setCurriculos] = useState([]);
    const [filtroCur, setFiltroCur] = useState({ vaga: '', status: 'P', buscaLocal: '' });

    const [areasDisponiveis, setAreasDisponiveis] = useState([]);
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const [showModalAvaliar, setShowModalAvaliar] = useState(false);
    const [selectedCur, setSelectedCur] = useState(null);
    const [avaliacao, setAvaliacao] = useState({ nota: 0, obs: "", entrevistado: "N", entrevistador: "" });

    // --- ESTADOS HUMOR DOS FUNCIONÁRIOS (FCV) ---
    const [filtroDataIniHumor, setFiltroDataIniHumor] = useState(getData10DiasAtras());
    const [filtroDataFimHumor, setFiltroDataFimHumor] = useState(hojeISO);
    const [filtroLojaHumor, setFiltroLojaHumor] = useState(localStorage.getItem("filial") || '999');
    const [filtroMatriculaHumor, setFiltroMatriculaHumor] = useState('');
    const [sentimentoSelecionado, setSentimentoSelecionado] = useState('0');
    const [resumoHumores, setResumoHumores] = useState({ total: 0, cont1: 0, cont2: 0, cont3: 0, cont4: 0, cont5: 0, media: 0 });
    const [detalhesHumores, setDetalhesHumores] = useState([]);

    // Ordenação
    const [ordemCampo, setOrdemCampo] = useState('nome');
    const [ordemDirecao, setOrdemDirecao] = useState('asc');

    // Modal de Calendário por Funcionário
    const [showModalCalendario, setShowModalCalendario] = useState(false);
    const [funcCalendario, setFuncCalendario] = useState(null);
    const [dadosCalendario, setDadosCalendario] = useState([]);
    const [loadingCalendario, setLoadingCalendario] = useState(false);

    // --- ESTADOS SOLICITAÇÕES DE VAGAS ---
    const [solicitacoesVagas, setSolicitacoesVagas] = useState([]);
    const [filialVagas, setFilialVagas] = useState('999');
    const [statusFiltroVagas, setStatusFiltroVagas] = useState('TODOS');
    const [selectedVaga, setSelectedVaga] = useState(null);
    const [showModalVaga, setShowModalVaga] = useState(false);
    const [showModalAcaoVaga, setShowModalAcaoVaga] = useState(false);
    const [formSalarioVaga, setFormSalarioVaga] = useState('');
    const [formCandidatoVaga, setFormCandidatoVaga] = useState('');
    const [formMotivoCancelamento, setFormMotivoCancelamento] = useState('');
    const [subTipoCancelamento, setSubTipoCancelamento] = useState('Desistência');
    const [formHorarioVaga, setFormHorarioVaga] = useState('');
    const [descHorarioVaga, setDescHorarioVaga] = useState('');
    const [loadingHorario, setLoadingHorario] = useState(false);

    const consultarHorario = async (codigo) => {
        if (!codigo) { setDescHorarioVaga(''); return; }
        setLoadingHorario(true);
        try {
            const res = await api.get(`/rh/vagas/horario/${codigo}`);
            if (res.data && res.data.descricao) setDescHorarioVaga(res.data.descricao);
        } catch (err) {
            setDescHorarioVaga('');
            Swal.fire('Atenção', err.response?.data?.erro || 'Erro ao consultar horário', 'error');
        } finally { setLoadingHorario(false); }
    };

    const statusVagasMap = {
        0: { label: '0 - Solicitado', color: 'secondary' },
        1: { label: '1 - Providenciando Candidato', color: 'warning' },
        2: { label: '2 - Aguardando Aprovação', color: 'info' },
        3: { label: '3 - Providenciando Documentos', color: 'primary' },
        4: { label: '4 - Aguardando Exames', color: 'dark' },
        5: { label: '5 - Candidato Aprovado', color: 'success' },
        9: { label: '9 - Desistência/Reprovado', color: 'danger' },
        10: { label: '10 - Concluído/Admitido', color: 'success' }
    };

    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewTipo, setPreviewTipo] = useState("");
    const [previewNome, setPreviewNome] = useState("");

    const formatarMoeda = (valor) => {
        if (!valor && valor !== 0) return "R$ 0,00";
        const num = typeof valor === 'number' ? valor : parseFloat(String(valor).replace(',', '.'));
        return isNaN(num) ? "R$ 0,00" : num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const handleSalarioChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        if (!value) { setFormSalarioVaga("R$ 0,00"); return; }
        const floatVal = (parseInt(value, 10) / 100);
        setFormSalarioVaga(floatVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
    };

    const handleOrdenar = (campo) => {
        if (ordemCampo === campo) {
            setOrdemDirecao(prev => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setOrdemCampo(campo);
            setOrdemDirecao('asc');
        }
    };

    const dadosOrdenados = useMemo(() => {
        return [...detalhesHumores].sort((a, b) => {
            let valA = a[ordemCampo] ?? a[ordemCampo.toUpperCase()] ?? '';
            let valB = b[ordemCampo] ?? b[ordemCampo.toUpperCase()] ?? '';

            if (ordemCampo === 'codfilial' || ordemCampo === 'chapa' || ordemCampo === 'total_respostas' || ordemCampo === 'media_func') {
                valA = Number(valA) || 0;
                valB = Number(valB) || 0;
            } else {
                valA = String(valA).toLowerCase();
                valB = String(valB).toLowerCase();
            }

            if (valA < valB) return ordemDirecao === 'asc' ? -1 : 1;
            if (valA > valB) return ordemDirecao === 'asc' ? 1 : -1;
            return 0;
        });
    }, [detalhesHumores, ordemCampo, ordemDirecao]);

    const renderSeta = (campo) => {
        if (ordemCampo !== campo) return ' ↕';
        return ordemDirecao === 'asc' ? ' ▲' : ' ▼';
    };

    const encodeBase64 = (str) => {
        try {
            if (!str) return "";
            const bytes = new TextEncoder().encode(str);
            let binary = "";
            bytes.forEach(b => binary += String.fromCharCode(b));
            return window.btoa(binary);
        } catch (e) { return ""; }
    };

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const pad = base64.length % 4;
            if (pad !== 0) base64 += "=".repeat(4 - pad);
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            return new TextDecoder("utf-8").decode(bytes);
        } catch (e) { return str; }
    };

    const loadHumores = useCallback(async () => {
        setLoading(true);
        try {
            const resResumo = await api.get(`/rh/sentimentos/resumo?dataini=${filtroDataIniHumor}&datafim=${filtroDataFimHumor}&filial=${filtroLojaHumor}`);
            setResumoHumores(resResumo.data || { total: 0, cont1: 0, cont2: 0, cont3: 0, cont4: 0, cont5: 0, media: 0 });

            const resDetalhes = await api.get(`/rh/sentimentos/detalhes?dataini=${filtroDataIniHumor}&datafim=${filtroDataFimHumor}&filial=${filtroLojaHumor}&sentimento=${sentimentoSelecionado}&matricula=${filtroMatriculaHumor}`);
            setDetalhesHumores(resDetalhes.data || []);
        } catch (err) {
            console.error('Erro ao carregar dados de humores:', err.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [filtroDataIniHumor, filtroDataFimHumor, filtroLojaHumor, sentimentoSelecionado, filtroMatriculaHumor]);

    const CalendarioReal = ({ dados, sentimentoEmEvidencia, dataInicio, dataFim }) => {
        const criarDataLocal = (strData) => {
            if (!strData) return new Date();
            const partes = strData.split('T')[0].split('-');
            return partes.length === 3 ? new Date(parseInt(partes[0], 10), parseInt(partes[1], 10) - 1, parseInt(partes[2], 10)) : new Date(strData);
        };

        const mapaSentimentos = useMemo(() => {
            const mapa = {};
            (dados || []).forEach(item => {
                const rawData = item.data_iso || item.DATA_ISO || item.data || item.DATA || '';
                const dataIso = String(rawData).split('T')[0].split(' ')[0];
                if (dataIso) mapa[dataIso] = item;
            });
            return mapa;
        }, [dados]);

        const mesesParaExibir = useMemo(() => {
            const dtIni = criarDataLocal(dataInicio);
            const dtFim = criarDataLocal(dataFim);
            const lista = [];

            let anoAtual = dtIni.getFullYear();
            let mesAtual = dtIni.getMonth();

            const anoFim = dtFim.getFullYear();
            const mesFim = dtFim.getMonth();

            while (anoAtual < anoFim || (anoAtual === anoFim && mesAtual <= mesFim)) {
                lista.push(new Date(anoAtual, mesAtual, 1));
                mesAtual++;
                if (mesAtual > 11) {
                    mesAtual = 0;
                    anoAtual++;
                }
            }
            return lista;
        }, [dataInicio, dataFim]);

        const diasSemana = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

        return (
            <div className="d-flex flex-column gap-3">
                {mesesParaExibir.map((dtMes) => {
                    const ano = dtMes.getFullYear();
                    const mes = dtMes.getMonth();
                    const primeiroDiaMes = new Date(ano, mes, 1);
                    const ultimoDiaMes = new Date(ano, mes + 1, 0);
                    const diaSemanaInicial = primeiroDiaMes.getDay();
                    const totalDias = ultimoDiaMes.getDate();

                    const celulas = [];
                    for (let i = 0; i < diaSemanaInicial; i++) {
                        celulas.push({ tipo: 'vazio', key: `vazio-${i}` });
                    }

                    for (let dia = 1; dia <= totalDias; dia++) {
                        const mesFmt = String(mes + 1).padStart(2, '0');
                        const diaFmt = String(dia).padStart(2, '0');
                        const chaveData = `${ano}-${mesFmt}-${diaFmt}`;
                        celulas.push({ tipo: 'dia', key: chaveData, dia, chaveData, registro: mapaSentimentos[chaveData] });
                    }

                    const nomeMes = dtMes.toLocaleString('pt-BR', { month: 'long', year: 'numeric' });

                    return (
                        <div key={`${ano}-${mes}`} className="border rounded p-2 p-md-3 bg-light shadow-sm">
                            <h6 className="text-center fw-bold text-uppercase text-arbor mb-2">{nomeMes}</h6>
                            <div className="d-grid text-center fw-bold text-muted mb-1 grade-dias-semana">
                                {diasSemana.map((d, i) => (
                                    <div key={i} className="py-1 bg-white border rounded small">{d}</div>
                                ))}
                            </div>
                            <div className="d-grid text-center gap-1 grade-calendario-dias">
                                {celulas.map((cel) => {
                                    if (cel.tipo === 'vazio') return <div key={cel.key} className="p-1 border-0"></div>;
                                    const reg = cel.registro;
                                    const sentimentoNum = reg ? (reg.sentimento || reg.SENTIMENTO) : null;
                                    const ehEvidencia = sentimentoEmEvidencia && String(sentimentoNum) === String(sentimentoEmEvidencia);

                                    return (
                                        <div
                                            key={cel.key}
                                            className={`celula-dia p-1 border rounded bg-white d-flex flex-column align-items-center justify-content-between ${ehEvidencia ? 'border-2 border-warning' : ''}`}
                                            style={{ backgroundColor: ehEvidencia ? '#fffde7' : '#ffffff' }}
                                        >
                                            <span className="num-dia fw-bold text-muted">{cel.dia}</span>
                                            <div className="d-flex align-items-center justify-content-center flex-grow-1">
                                                {reg ? (
                                                    <div className="emoji-calendario">{carinhasMap[sentimentoNum]?.emoji}</div>
                                                ) : (
                                                    <span className="text-light fs-6">•</span>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    const abrirCalendarioFuncionario = async (item) => {
        setFuncCalendario(item);
        setShowModalCalendario(true);
        setLoadingCalendario(true);
        try {
            const chapa = item.chapa || item.CHAPA;
            const res = await api.get(`/rh/sentimentos/calendario/${chapa}?dataini=${filtroDataIniHumor}&datafim=${filtroDataFimHumor}`);
            setDadosCalendario(res.data || []);
        } catch (err) {
            setDadosCalendario([]);
        } finally {
            setLoadingCalendario(false);
        }
    };

    const loadSolicitacoesVagas = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.get(`/rh/vagas/solicitacoes?filial=${filialVagas}&status=${statusFiltroVagas}`);
            setSolicitacoesVagas(res.data || []);
        } catch (err) {
            console.error('Erro ao buscar solicitações de vagas:', err);
        } finally {
            setLoading(false);
        }
    }, [filialVagas, statusFiltroVagas]);

    const handleOpenDetailVaga = (item) => {
        setSelectedVaga(item);
        setFormSalarioVaga(formatarMoeda(item.salario || 0));
        setFormCandidatoVaga(item.candidato || item.indicado || '');
        setFormHorarioVaga(item.horario || item.HORARIO || '');
        setDescHorarioVaga(item.horariodesc || item.HORARIODESC || '');

        if (item.horario && !item.horariodesc) {
            consultarHorario(item.horario);
        }
        setShowModalVaga(true);
    };

    const ExecutarAcaoStatusVaga = async (novoStatus, payloadExtra = {}) => {
        setLoading(true);
        const salarioLimpo = formSalarioVaga ? formSalarioVaga.replace(/[R$\s.]/g, '').replace(',', '.') : '0';

        try {
            await api.post('/rh/vagas/status', {
                pedido: selectedVaga.pedido,
                status: novoStatus,
                matricularh: chapaRH,
                salario: salarioLimpo,
                candidato: formCandidatoVaga,
                indicado: formCandidatoVaga,
                horario: formHorarioVaga,
                ...payloadExtra
            });
            setShowModalVaga(false);
            setShowModalAcaoVaga(false);
            Swal.fire("Sucesso", "Status da vaga atualizado com sucesso!", "success");
            loadSolicitacoesVagas();
        } catch (err) {
            Swal.fire("Erro", 'Erro ao atualizar status: ' + (err.response?.data?.erro || err.message), "error");
        } finally {
            setLoading(false);
        }
    };

    const handleDesistenciaOuReprovacaoVaga = async () => {
        if (!formMotivoCancelamento) {
            return Swal.fire("Atenção", 'Informe o motivo!', "warning");
        }
        setLoading(true);
        try {
            await api.post('/rh/vagas/desistencia-reprovacao', {
                pedido: selectedVaga.pedido,
                tipo_acao: subTipoCancelamento,
                motivo: formMotivoCancelamento,
                matricularh: chapaRH
            });
            setShowModalAcaoVaga(false);
            setShowModalVaga(false);
            Swal.fire("Sucesso", "Solicitação cancelada e nova vaga gerada!", "success");
            loadSolicitacoesVagas();
        } catch (err) {
            Swal.fire("Erro", 'Erro: ' + (err.response?.data?.erro || err.message), "error");
        } finally {
            setLoading(false);
        }
    };

    const loadChamados = useCallback(async (isPolling = false) => {
        if (viewMode !== 'chamados') return;
        if (!isPolling) setLoading(true);
        try {
            const response = await api.get(`/rh/dashboard?status=${filtroStatus}`);
            const novosDados = response.data || [];
            if (filtroStatus === "0" && novosDados.length > qtdAnteriorRef.current && qtdAnteriorRef.current !== 0) {
                setShowAlerta(true);
            }
            qtdAnteriorRef.current = novosDados.length;
            setChamados(novosDados);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    }, [filtroStatus, viewMode]);

    const loadCurriculos = useCallback(async () => {
        setLoading(true);
        try {
            let vagaParam = '';
            let statusParam = filtroCur.status;

            if (areasSelecionadas.length > 0) {
                vagaParam = areasSelecionadas.map(a => a.value).join(',');
                statusParam = '';
            } else {
                vagaParam = filtroCur.vaga;
            }

            const res = await api.get(`/rh/curriculos?area=${vagaParam}&status=${statusParam}`);
            let dados = res.data || [];

            if (areasSelecionadas.length > 0) {
                dados.sort((a, b) => (b.classificacao_nota || 0) - (a.classificacao_nota || 0));
            }

            if (filtroCur.buscaLocal) {
                const termo = filtroCur.buscaLocal.toLowerCase().trim();

                dados = dados.filter(cur => {
                    const nome = (cur.nome_candidato || '').toLowerCase();
                    const endereco = (cur.endereco_completo || '').toLowerCase();
                    const loja = (cur.loja_preferencia || '').toLowerCase();
                    const vaga = (cur.vaga_interesse || '').toLowerCase();
                    const arquivo = (cur.nome_arquivo || '').toLowerCase();
                    const apresentacao = (cur.texto_apresentacao || '').toLowerCase();

                    if (termo === 'freelancer' || termo === 'freelance' || termo === 'temporario') {
                        return arquivo.includes('freelancer') || apresentacao.includes('freelancer');
                    }

                    return nome.includes(termo) || endereco.includes(termo) || loja.includes(termo) || vaga.includes(termo) || arquivo.includes(termo);
                });
            }

            setCurriculos(dados);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    }, [filtroCur, areasSelecionadas]);

    const loadAreas = async () => {
        try {
            const res = await api.get('/externo/areas');
            setAreasDisponiveis((res.data || []).map(a => ({
                value: a.id_area || a.ID_AREA,
                label: a.descricao || a.DESCRICAO
            })));
        } catch (err) { console.error(err); }
    };

    useEffect(() => {
        if (viewMode === 'chamados') {
            loadChamados();
            const interval = setInterval(() => loadChamados(true), 20000);
            return () => clearInterval(interval);
        } else if (viewMode === 'curriculos') {
            loadAreas();
            loadCurriculos();
        } else if (viewMode === 'vagas') {
            loadSolicitacoesVagas();
        } else if (viewMode === 'humores') {
            loadHumores();
        }
    }, [loadChamados, loadCurriculos, loadSolicitacoesVagas, loadHumores, viewMode]);

    const abrirAvaliacao = (cur) => {
        setSelectedCur(cur);
        setAvaliacao({
            nota: cur.classificacao_nota || 0,
            obs: cur.obs_entrevista || "",
            entrevistado: cur.ja_entrevistado || "N",
            entrevistador: ""
        });
        setShowModalAvaliar(true);
    };

    const handleSalvarAvaliacao = async () => {
        if (avaliacao.nota === 0) return Swal.fire("Aviso", "Selecione uma nota de 1 a 5.", "warning");
        try {
            await api.post('/rh/curriculo/avaliar', {
                id_candidato: selectedCur.id_candidato,
                classificacao_nota: avaliacao.nota,
                obs_entrevista: encodeBase64(avaliacao.obs),
                ja_entrevistado: avaliacao.entrevistado,
                entrevistador: nomeRHLogado
            });
            Swal.fire("Sucesso", "Avaliação gravada com sucesso!", "success");
            setShowModalAvaliar(false);
            loadCurriculos();
        } catch (err) {
            Swal.fire("Erro", "Falha ao gravar avaliação.", "error");
        }
    };

    const handleBuscarEVerArquivoChamado = async (idChamado, idInteracao, nomeArquivo) => {
        try {
            setLoading(true);
            const response = await api.get(`/rh/chamado/${idChamado}/arquivo?id_interacao=${idInteracao}`);
            const dados = response.data;
            const base64Dados = (Array.isArray(dados) && dados.length > 0 && (dados[0].anexo_blob || dados[0].ANEXO_BLOB)) || dados?.anexo_blob;

            if (base64Dados) abrirPreviewArquivo(base64Dados, nomeArquivo);
            else Swal.fire('Aviso', 'Arquivo não encontrado.', 'warning');
        } catch (err) {
            Swal.fire('Erro', 'Falha ao recuperar anexo.', 'error');
        } finally { setLoading(false); }
    };

    const handleBuscarEVerCurriculo = async (email, nomeArquivo) => {
        try {
            setLoading(true);
            const response = await api.get(`/rh/curriculos/arquivo?email=${email}`);
            let base64Dados = "";
            if (Array.isArray(response.data) && response.data.length > 0) base64Dados = response.data[0].curriculo_blob;
            else if (response.data) base64Dados = response.data.curriculo_blob;

            if (base64Dados) abrirPreviewArquivo(base64Dados, nomeArquivo || "curriculo.pdf");
            else Swal.fire('Aviso', 'Campo de arquivo vazio.', 'warning');
        } catch (err) {
            Swal.fire('Erro', 'Falha ao conectar para baixar arquivo.', 'error');
        } finally { setLoading(false); }
    };

    const abrirPreviewArquivo = (base64Dados, nomeArquivo) => {
        try {
            if (!base64Dados) return Swal.fire('Erro', 'Conteúdo não encontrado.', 'error');
            const base64Limpo = base64Dados.replace(/^data:.*;base64,/, "").replace(/\s/g, "").trim();
            const byteCharacters = atob(base64Limpo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
            const byteArray = new Uint8Array(byteNumbers);

            let type = "application/octet-stream";
            const ext = (nomeArquivo || "").toLowerCase();
            if (ext.endsWith(".pdf")) type = "application/pdf";
            else if (ext.endsWith(".png")) type = "image/png";
            else if (ext.endsWith(".jpg") || ext.endsWith(".jpeg")) type = "image/jpeg";

            const blob = new Blob([byteArray], { type });
            setPreviewUrl(URL.createObjectURL(blob));
            setPreviewTipo(type);
            setPreviewNome(nomeArquivo || "arquivo");
            setShowPreview(true);
        } catch (err) {
            Swal.fire('Erro', 'Falha ao abrir o arquivo.', 'error');
        }
    };

    const loadAssuntosFaq = async () => {
        try {
            const res = await api.get('/rh/assuntos');
            setAssuntosFaq(res.data || []);
        } catch (err) { console.error(err); }
    };

    const handleAbrirResposta = async (chamado) => {
        const id = chamado?.id_chamado || chamado?.ID_CHAMADO;
        if (!id) return;
        setSelected(chamado);
        setRespostaHtml(""); setSalvarFaq(false); setArquivoRH(null);
        setShowResponder(true); setLoadingChat(true);
        try {
            const res = await api.get(`/rh/chamado/${id}/interacoes`);
            setMensagens(res.data || []);
        } catch (err) { setMensagens([]); } finally { setLoadingChat(false); }
    };

    const handleEnviarResposta = async () => {
        const textoPuro = respostaHtml.replace(/<(.|\n)*?>/g, '').trim();
        if (!textoPuro) return Swal.fire('Atenção', 'Digite uma resposta!', 'warning');
        try {
            setLoading(true);
            let base64File = "";
            if (arquivoRH) {
                const reader = new FileReader();
                base64File = await new Promise((resolve, reject) => {
                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(arquivoRH);
                });
            }
            const payload = {
                id_chamado: selected?.id_chamado || selected?.ID_CHAMADO,
                id_assunto: selected?.id_assunto || selected?.ID_ASSUNTO,
                chapa: chapaRH,
                mensagem: encodeBase64(respostaHtml),
                anexo_base64: base64File,
                nome_arquivo: arquivoRH ? arquivoRH.name : "",
                salvar_faq: salvarFaq
            };
            await api.post('/rh/responder', payload);
            Swal.fire('Sucesso', 'Resposta enviada!', 'success');
            setShowResponder(false);
            loadChamados();
        } catch (err) {
            Swal.fire('Erro', 'Erro ao enviar resposta.', 'error');
        } finally { setLoading(false); }
    };

    const selecionarParaEditar = (item) => {
        const id = Number(item.id_assunto ?? item.ID_ASSUNTO);
        const titulo = item.descricao_assunto || item.DESCRICAO_ASSUNTO || "";
        const textoBase64 = item.texto_faq_assunto || item.TEXTO_FAQ_ASSUNTO || "";
        const ativo = item.ativo_assunto || item.ATIVO_ASSUNTO || "S";
        let respostaDecodificada = "";
        if (textoBase64) {
            try {
                const step1 = decodeBase64(textoBase64);
                respostaDecodificada = decodeBase64(step1) || step1;
            } catch { respostaDecodificada = decodeBase64(textoBase64); }
        }
        setModoFaq("edicao"); setFaqId(id); setFaqPergunta(titulo); setFaqResposta(respostaDecodificada); setFaqAtivo(ativo);
        setTimeout(() => tituloRef.current?.focus(), 50);
    };

    const prepararNovaFaq = () => {
        setModoFaq("novo"); setFaqId(Math.random()); setFaqPergunta(""); setFaqResposta(""); setFaqAtivo("S");
        setTimeout(() => { setFaqId(0); tituloRef.current?.focus(); }, 10);
    };

    const handleSalvarFaqDireto = async () => {
        if (!faqPergunta.trim()) return Swal.fire("Aviso", "O Título não pode estar vazio!", "warning");
        try {
            const payload = {
                id_assunto: modoFaq === "novo" ? 0 : faqId,
                descricao_assunto: faqPergunta,
                texto_faq_assunto: encodeBase64(faqResposta),
                ativo_assunto: faqAtivo
            };
            await api.post('/rh/faq/manutencao', payload);
            Swal.fire("Sucesso", modoFaq === "novo" ? "FAQ cadastrada!" : "FAQ atualizada!", "success");
            await loadAssuntosFaq();
            prepararNovaFaq();
        } catch (err) { Swal.fire("Erro", "Falha ao gravar FAQ.", "error"); }
    };

    const faqsFiltradas = assuntosFaq.filter(a => (a.descricao_assunto || a.DESCRICAO_ASSUNTO || "").toLowerCase().includes(buscaFaq.toLowerCase()));
    const podeResponder = (selected?.status_chamado ?? selected?.STATUS_CHAMADO) === 0;

    return (
        <div className="layout-rh d-flex flex-column min-vh-100">
            <Menu modulo="ARBOR" />
            <ToastContainer position="top-end" className="p-3">
                <Toast show={showAlerta} onClose={() => setShowAlerta(false)} className="bg-arbor text-white" delay={5000} autohide>
                    <Toast.Header><strong className="me-auto text-arbor">🔔 Novo Chamado</strong></Toast.Header>
                    <Toast.Body className="text-white">Há novas solicitações na fila!</Toast.Body>
                </Toast>
            </ToastContainer>

            <Container fluid className="flex-grow-1 px-3 px-md-4 py-4 main-content-container">
                <Row className="align-items-start g-3">

                    {/* Sidebar Lateral */}
                    <Col xs={12} md={3} lg={2} className="sidebar-desktop">
                        <div className="sidebar-sticky-wrapper">
                            <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                                <Card.Header className="bg-arbor text-white fw-bold py-2 px-3 small">
                                    Navegação RH
                                </Card.Header>
                                <ListGroup variant="flush">
                                    <ListGroup.Item action active={viewMode === 'chamados'} onClick={() => setViewMode('chamados')}>
                                        💬 Chamados RH
                                    </ListGroup.Item>
                                    <ListGroup.Item action active={viewMode === 'vagas'} onClick={() => setViewMode('vagas')}>
                                        🏪 Vagas das Lojas
                                    </ListGroup.Item>
                                    <ListGroup.Item action active={viewMode === 'curriculos'} onClick={() => setViewMode('curriculos')}>
                                        📄 Banco de Currículos
                                    </ListGroup.Item>
                                    <ListGroup.Item action active={viewMode === 'humores'} onClick={() => setViewMode('humores')}>
                                        🎭 Humor dos Funcionários
                                    </ListGroup.Item>
                                </ListGroup>

                                {viewMode === 'chamados' && (
                                    <>
                                        <Card.Header className="bg-light fw-bold border-top py-2 px-3 extra-small text-muted">Status Chamados</Card.Header>
                                        <ListGroup variant="flush">
                                            <ListGroup.Item action active={filtroStatus === "0"} onClick={() => setFiltroStatus("0")}>📥 Pendentes</ListGroup.Item>
                                            <ListGroup.Item action active={filtroStatus === "2"} onClick={() => setFiltroStatus("2")}>✅ Respondidos</ListGroup.Item>
                                            <ListGroup.Item action active={filtroStatus === "3"} onClick={() => setFiltroStatus("3")}>🔒 Finalizados</ListGroup.Item>
                                        </ListGroup>
                                    </>
                                )}

                                {viewMode === 'vagas' && (
                                    <>
                                        <Card.Header className="bg-light fw-bold border-top py-2 px-3 extra-small text-muted">Status Vagas</Card.Header>
                                        <ListGroup variant="flush">
                                            {['TODOS', '0', '1', '2', '3', '4', '5', '9', '10'].map(st => (
                                                <ListGroup.Item
                                                    key={st}
                                                    action
                                                    active={statusFiltroVagas === st}
                                                    onClick={() => { setStatusFiltroVagas(st); }}
                                                >
                                                    {st === 'TODOS' ? '📋 Todos os Status' : statusVagasMap[st]?.label}
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </>
                                )}

                                {viewMode === 'curriculos' && (
                                    <>
                                        <Card.Header className="bg-light fw-bold border-top py-2 px-3 extra-small text-muted">Status Currículos</Card.Header>
                                        <ListGroup variant="flush">
                                            <ListGroup.Item action active={filtroCur.status === "P"} onClick={() => setFiltroCur({ ...filtroCur, status: "P" })}>📥 Pendentes</ListGroup.Item>
                                            <ListGroup.Item action active={filtroCur.status === "A"} onClick={() => setFiltroCur({ ...filtroCur, status: "A" })}>✅ Avaliados</ListGroup.Item>
                                        </ListGroup>
                                    </>
                                )}

                                <ListGroup variant="flush">
                                    <ListGroup.Item action className="text-arbor fw-bold border-top py-2.5" onClick={() => { loadAssuntosFaq(); setShowModalFaq(true); }}>⚙️ Gerenciar FAQs</ListGroup.Item>
                                </ListGroup>
                            </Card>
                        </div>
                    </Col>

                    {/* Conteúdo Principal */}
                    <Col xs={12} md={9} lg={10} className="content-desktop">

                        {/* VIEW HUMORES / SENTIMENTOS */}
                        {viewMode === 'humores' && (
                            <div>
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2">
                                    <div>
                                        <h4 className="fw-bold text-dark mb-0">Pesquisa de Clima & Sentimentos</h4>
                                        <p className="text-muted small mb-0">Acompanhamento do estado emocional da equipe no período</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 bg-white px-3 py-2 rounded border shadow-sm align-self-start align-self-md-auto">
                                        <span className="fw-bold small text-muted">Média do Período:</span>
                                        <span className="fs-4 fw-bold text-arbor">{resumoHumores.media || '0.0'}</span>
                                        <span className="fs-3">{carinhasMap[Math.round(resumoHumores.media || 3)]?.emoji}</span>
                                    </div>
                                </div>

                                {/* FILTROS */}
                                <Card className="border-0 shadow-sm mb-4">
                                    <Card.Body className="p-3">
                                        <Row className="g-2 align-items-end">
                                            <Col xs={6} md={3}>
                                                <Form.Label className="small fw-bold mb-1">Data Início</Form.Label>
                                                <Form.Control size="sm" type="date" value={filtroDataIniHumor} onChange={e => setFiltroDataIniHumor(e.target.value)} />
                                            </Col>
                                            <Col xs={6} md={3}>
                                                <Form.Label className="small fw-bold mb-1">Data Fim</Form.Label>
                                                <Form.Control size="sm" type="date" value={filtroDataFimHumor} onChange={e => setFiltroDataFimHumor(e.target.value)} />
                                            </Col>
                                            <Col xs={6} md={2}>
                                                <Form.Label className="small fw-bold mb-1">Loja / Filial</Form.Label>
                                                <Form.Control size="sm" type="text" value={filtroLojaHumor} onChange={e => setFiltroLojaHumor(e.target.value)} placeholder="999 = Todas" />
                                            </Col>
                                            <Col xs={6} md={2}>
                                                <Form.Label className="small fw-bold mb-1">Matrícula</Form.Label>
                                                <Form.Control size="sm" type="text" value={filtroMatriculaHumor} onChange={e => setFiltroMatriculaHumor(e.target.value)} placeholder="Opcional" />
                                            </Col>
                                            <Col xs={12} md={2}>
                                                <Button size="sm" className="w-100 fw-bold btn-arbor" onClick={loadHumores} disabled={loading}>
                                                    {loading ? <Spinner animation="border" size="sm" /> : "Consultar"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                {/* CARDS DE SENTIMENTOS */}
                                <div className="grid-humores-cards mb-4">
                                    {[1, 2, 3, 4, 5].map((st) => {
                                        const count = resumoHumores[`cont${st}`] || 0;
                                        const pct = resumoHumores.total > 0 ? ((count / resumoHumores.total) * 100).toFixed(1) : "0.0";
                                        const isSelected = sentimentoSelecionado === String(st);

                                        return (
                                            <Card
                                                key={st}
                                                className={`item-carinha text-center transition-all ${isSelected ? 'border-arbor shadow' : 'border-light shadow-sm'}`}
                                                style={{ cursor: 'pointer', backgroundColor: isSelected ? '#fdf2f2' : '#fff' }}
                                                onClick={() => setSentimentoSelecionado(isSelected ? '0' : String(st))}
                                            >
                                                <Card.Body className="p-2">
                                                    <div className="emoji-header">{carinhasMap[st].emoji}</div>
                                                    <div className="fw-bold small text-muted mb-1">{carinhasMap[st].rotulo}</div>
                                                    <Badge bg={carinhasMap[st].cor} className="w-100 fs-7">
                                                        {pct}% ({count})
                                                    </Badge>
                                                </Card.Body>
                                            </Card>
                                        );
                                    })}
                                </div>

                                {/* LISTA COM SUPORTE A ORDENAÇÃO E FOTO */}
                                <Card className="border-0 shadow-sm">
                                    <Card.Header className="bg-white fw-bold d-flex justify-content-between align-items-center py-3">
                                        <span>Lista de Colaboradores ({dadosOrdenados.length})</span>
                                        {sentimentoSelecionado !== '0' && (
                                            <Button size="sm" variant="outline-secondary" onClick={() => setSentimentoSelecionado('0')}>
                                                Limpar Filtro de Carinha
                                            </Button>
                                        )}
                                    </Card.Header>

                                    {loading ? (
                                        <div className="text-center py-5">
                                            <Spinner animation="border" className="text-arbor" />
                                            <div className="text-muted mt-2 fw-bold small">A carregar colaboradores...</div>
                                        </div>
                                    ) : (
                                        <>
                                            {/* TABELA DESKTOP */}
                                            <div className="d-none d-md-block">
                                                <Table hover responsive className="mb-0 align-middle">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th style={{ width: '60px' }}>Foto</th>
                                                            <th className="sortable" style={{ width: '70px' }} onClick={() => handleOrdenar('codfilial')}>
                                                                Loja{renderSeta('codfilial')}
                                                            </th>
                                                            <th className="sortable" style={{ width: '100px' }} onClick={() => handleOrdenar('chapa')}>
                                                                Matrícula{renderSeta('chapa')}
                                                            </th>
                                                            <th className="sortable" onClick={() => handleOrdenar('nome')}>
                                                                Funcionário{renderSeta('nome')}
                                                            </th>
                                                            <th>Função / Seção</th>
                                                            <th className="text-center sortable" style={{ width: '110px' }} onClick={() => handleOrdenar('total_respostas')}>
                                                                Respostas{renderSeta('total_respostas')}
                                                            </th>
                                                            <th className="text-center" style={{ width: '100px' }}>Humor Média</th>
                                                            <th className="text-center sortable" style={{ width: '90px' }} onClick={() => handleOrdenar('media_func')}>
                                                                Média{renderSeta('media_func')}
                                                            </th>
                                                            <th className="text-center" style={{ width: '140px' }}>Histórico</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dadosOrdenados.map((item, idx) => {
                                                            const chapa = item.chapa || item.CHAPA;
                                                            const mediaFunc = item.media_func || item.MEDIA_FUNC || 0;
                                                            const numLoja = String(item.codfilial || item.CODFILIAL || '').padStart(2, '0');

                                                            return (
                                                                <tr key={idx}>
                                                                    <td>
                                                                        <FotoFuncionarioAvatar
                                                                            chapa={chapa}
                                                                            nome={item.nome || item.NOME || ""}
                                                                            info01={`Matrícula: ${chapa}`}
                                                                            info02={`Loja ${numLoja}`}
                                                                            onSelectFoto={setFotoSelecionada}
                                                                        />
                                                                    </td>
                                                                    <td className="fw-bold">{numLoja}</td>
                                                                    <td className="fw-bold">{chapa}</td>
                                                                    <td className="fw-bold text-uppercase">{item.nome || item.NOME}</td>
                                                                    <td className="small text-muted">
                                                                        <div>{item.funcao || item.FUNCAO}</div>
                                                                        <small className="text-secondary">{item.secao || item.SECAO}</small>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <Badge bg="light" text="dark" className="border px-2 py-1">
                                                                            {item.total_respostas || item.TOTAL_RESPOSTAS || 1} registro(s)
                                                                        </Badge>
                                                                    </td>
                                                                    <td className="fs-4 text-center">{carinhasMap[Math.round(mediaFunc)]?.emoji || '😐'}</td>
                                                                    <td className="text-center fw-bold text-arbor fs-6">{Number(mediaFunc).toFixed(1)}</td>
                                                                    <td className="text-center">
                                                                        <Button size="sm" variant="outline-danger" className="fw-bold" onClick={() => abrirCalendarioFuncionario(item)}>
                                                                            📅 Ver Histórico
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </div>

                                            {/* CARDS RESPONSIVOS MOBILE */}
                                            <div className="d-block d-md-none p-2">
                                                {dadosOrdenados.map((item, idx) => {
                                                    const chapa = item.chapa || item.CHAPA;
                                                    const mediaFunc = item.media_func || item.MEDIA_FUNC || 0;
                                                    const numLoja = String(item.codfilial || item.CODFILIAL || '').padStart(2, '0');

                                                    return (
                                                        <Card key={idx} className="mb-2 border border-light shadow-sm">
                                                            <Card.Body className="p-3">
                                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <FotoFuncionarioAvatar
                                                                            chapa={chapa}
                                                                            nome={item.nome || item.NOME || ""}
                                                                            info01={`Matrícula: ${chapa}`}
                                                                            info02={`Loja ${numLoja}`}
                                                                            onSelectFoto={setFotoSelecionada}
                                                                        />
                                                                        <div>
                                                                            <Badge bg="secondary" className="mb-1">{numLoja}</Badge>
                                                                            <h6 className="fw-bold mb-0 text-uppercase" style={{ fontSize: '0.85rem' }}>{item.nome || item.NOME}</h6>
                                                                            <small className="text-muted d-block">Matrícula: {chapa}</small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <span className="fs-2 d-block leading-none">{carinhasMap[Math.round(mediaFunc)]?.emoji || '😐'}</span>
                                                                        <span className="fw-bold text-arbor small">Média {Number(mediaFunc).toFixed(1)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="small text-muted mb-2 border-top pt-2">
                                                                    <div><strong>Função:</strong> {item.funcao || item.FUNCAO}</div>
                                                                    <div><strong>Seção:</strong> {item.secao || item.SECAO}</div>
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                                                                    <span className="x-small text-muted">{item.total_respostas || item.TOTAL_RESPOSTAS || 1} resposta(s)</span>
                                                                    <Button size="sm" variant="outline-danger" className="fw-bold py-1 px-2" onClick={() => abrirCalendarioFuncionario(item)}>
                                                                        📅 Histórico
                                                                    </Button>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    );
                                                })}
                                            </div>

                                            {dadosOrdenados.length === 0 && (
                                                <div className="text-center py-4 text-muted">
                                                    Nenhum colaborador encontrado para este filtro no período.
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Card>
                            </div>
                        )}

                        {/* OUTRAS VIEWS (VAGAS, CURRÍCULOS, CHAMADOS) */}
                        {viewMode === 'vagas' && (
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h4 className="fw-bold text-dark mb-0">Solicitações de Vagas (Lojas)</h4>
                                        <p className="text-muted small mb-0">Acompanhe as requisições enviadas pelas filiais</p>
                                    </div>
                                    <Badge className="bg-arbor rounded-pill px-3 py-2">
                                        Total: {solicitacoesVagas.length}
                                    </Badge>
                                </div>

                                <Card className="border-0 shadow-sm mb-3">
                                    <Card.Body className="p-3">
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="small fw-bold">Filtrar por Filial/Loja:</Form.Label>
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        value={filialVagas}
                                                        onChange={(e) => setFilialVagas(e.target.value)}
                                                        placeholder="Digite o número da loja (999 para todas)"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                <Card className="border-0 shadow-sm">
                                    <Table hover responsive className="mb-0 align-middle">
                                        <thead className="table-dark">
                                            <tr>
                                                <th style={{ width: '80px' }}>Pedido</th>
                                                <th style={{ width: '90px' }}>Loja</th>
                                                <th style={{ width: '180px' }}>Status</th>
                                                <th style={{ width: '120px' }}>Seção</th>
                                                <th style={{ width: '160px' }}>Função</th>
                                                <th>Candidato / Indicado</th>
                                                <th style={{ width: '130px' }}>Data Pedido</th>
                                                <th className="text-center" style={{ width: '110px' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan={8} className="text-center py-5">
                                                        <Spinner animation="border" className="text-arbor" />
                                                    </td>
                                                </tr>
                                            ) : solicitacoesVagas.map((item) => (
                                                <tr key={item.pedido}>
                                                    <td className="fw-bold">#{item.pedido}</td>
                                                    <td>Loja {String(item.loja).padStart(2, '0')}</td>
                                                    <td>
                                                        <Badge bg={statusVagasMap[item.status]?.color || 'secondary'}>
                                                            {statusVagasMap[item.status]?.label}
                                                        </Badge>
                                                    </td>
                                                    <td>{item.setor_nome || item.setor}</td>
                                                    <td>{item.funcao}</td>
                                                    <td className="text-break">{item.candidato || item.indicado || '-'}</td>
                                                    <td className="small">{formatarDataHora(item.datapedido).split(',')[0]}</td>
                                                    <td className="text-center">
                                                        <Button size="sm" variant="outline-danger" onClick={() => handleOpenDetailVaga(item)}>
                                                            Gerenciar
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {!loading && solicitacoesVagas.length === 0 && (
                                                <tr>
                                                    <td colSpan={8} className="text-center py-4 text-muted">
                                                        Nenhuma solicitação encontrada para este filtro.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Card>
                            </div>
                        )}

                        {viewMode === 'curriculos' && (
                            <div style={{ maxWidth: '1100px', margin: '0' }}>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div>
                                        <h4 className="fw-bold text-dark mb-0">Banco de Currículos</h4>
                                        <p className="text-muted small mb-0">Gerencie e analise os candidatos disponíveis</p>
                                    </div>
                                    <Badge className="bg-arbor rounded-pill px-3">
                                        {curriculos.length} Candidatos
                                    </Badge>
                                </div>

                                <Card className="border-0 shadow-sm mb-4">
                                    <Card.Body className="p-2">
                                        <Row className="g-2 align-items-center">
                                            <Col md={4}>
                                                <InputGroup size="sm">
                                                    <InputGroup.Text className="bg-white border-end-0 text-muted">
                                                        <i className="bi bi-search"></i>
                                                    </InputGroup.Text>
                                                    <Form.Control
                                                        className="border-start-0 ps-0"
                                                        placeholder="Nome, cidade ou 'freelancer'..."
                                                        value={filtroCur.buscaLocal}
                                                        onChange={e => setFiltroCur({ ...filtroCur, buscaLocal: e.target.value })}
                                                        style={{ height: '38px' }}
                                                    />
                                                    {filtroCur.buscaLocal && (
                                                        <Button variant="outline-secondary" onClick={() => setFiltroCur({ ...filtroCur, buscaLocal: '' })}>✕</Button>
                                                    )}
                                                </InputGroup>
                                            </Col>

                                            <Col md={4}>
                                                <Select
                                                    isMulti
                                                    options={areasDisponiveis}
                                                    placeholder="Todas as áreas de atuação"
                                                    value={areasSelecionadas}
                                                    onChange={setAreasSelecionadas}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        control: (base) => ({ ...base, minHeight: '38px', fontSize: '14px', border: '1px solid #dee2e6', boxShadow: 'none' })
                                                    }}
                                                />
                                            </Col>

                                            <Col md={2}>
                                                <Button
                                                    variant={filtroCur.buscaLocal.toLowerCase() === 'freelancer' ? "success" : "outline-success"}
                                                    size="sm"
                                                    className="w-100 fw-bold"
                                                    onClick={() => setFiltroCur({ ...filtroCur, buscaLocal: filtroCur.buscaLocal.toLowerCase() === 'freelancer' ? '' : 'freelancer' })}
                                                    style={{ height: '38px', fontSize: '12px' }}
                                                >
                                                    🤝 FREELANCERS
                                                </Button>
                                            </Col>

                                            <Col md={2}>
                                                <Button size="sm" className="w-100 fw-bold btn-arbor" onClick={loadCurriculos} style={{ height: '38px' }}>
                                                    FILTRAR
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                <Card className="border-0 shadow-sm">
                                    <Table hover responsive className="mb-0">
                                        <thead>
                                            <tr className="bg-light">
                                                <th className="border-0 ps-3 py-3 text-muted x-small" style={{ width: '45%' }}>INFORMAÇÕES DO CANDIDATO</th>
                                                <th className="border-0 text-center py-3 text-muted x-small">QUALIFICAÇÃO</th>
                                                <th className="border-0 text-center py-3 text-muted x-small">STATUS</th>
                                                <th className="border-0 text-center py-3 text-muted x-small">AÇÕES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-5">
                                                        <Spinner animation="border" className="text-arbor" size="sm" />
                                                    </td>
                                                </tr>
                                            ) : (
                                                curriculos.map(cur => (
                                                    <tr key={cur.id_candidato} className="align-middle border-bottom">
                                                        <td className="ps-3 py-3">
                                                            <div className="d-flex align-items-center">
                                                                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px', fontSize: '1.2rem' }}>
                                                                    {cur.nome_arquivo === 'FREELANCER' ? '⚡' : '👤'}
                                                                </div>
                                                                <div>
                                                                    <div className="fw-bold text-dark text-uppercase d-flex align-items-center gap-2" style={{ fontSize: '0.9rem' }}>
                                                                        {cur.nome_candidato}
                                                                        {cur.nome_arquivo === 'FREELANCER' && <Badge bg="success" style={{ fontSize: '10px' }}>FREELANCER</Badge>}
                                                                    </div>
                                                                    <div className="text-muted small">{cur.areas_descricoes || 'Área não definida'}</div>
                                                                    <div className="text-arbor" style={{ fontSize: '0.75rem' }}>
                                                                        Enviado em: {formatarDataHora(cur.data_cadastro).split(',')[0]}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="d-flex flex-column align-items-center">
                                                                <div className="fw-bold mb-1" style={{ fontSize: '0.85rem' }}>{cur.classificacao_nota || 0}/5</div>
                                                                <div className="progress w-75" style={{ height: '6px' }}>
                                                                    <div
                                                                        className={`progress-bar bg-${cur.classificacao_nota >= 4 ? 'success' : cur.classificacao_nota >= 3 ? 'warning' : 'danger'}`}
                                                                        style={{ width: `${(cur.classificacao_nota || 0) * 20}%` }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            {cur.ja_entrevistado === 'S' ?
                                                                <Badge bg="info" className="fw-normal">Entrevistado</Badge> :
                                                                <Badge bg="light" className="text-muted fw-normal border">Pendente</Badge>
                                                            }
                                                        </td>
                                                        <td className="text-center">
                                                            <Button variant="outline-dark" size="sm" className="rounded-pill px-3 btn-analisar" onClick={() => abrirAvaliacao(cur)}>
                                                                Analisar
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </Card>
                            </div>
                        )}

                        {viewMode === 'chamados' && (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="fw-bold text-secondary">Gestão de Chamados RH</h5>
                                    <Badge className="bg-arbor">Total: {chamados.length}</Badge>
                                </div>
                                {loading && <div className="text-center py-5"><Spinner animation="border" className="text-arbor" /></div>}
                                <div className="lista-chamados">
                                    {!loading && chamados.map(item => {
                                        const chapa = item.chapa;

                                        return (
                                            <Card
                                                key={item.id_chamado || item.ID_CHAMADO}
                                                className="mb-3 border-0 shadow-sm card-rh-item"
                                                onClick={() => handleAbrirResposta(item)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Card.Body style={{ position: 'relative', paddingRight: '130px' }}>
                                                    <Row className="align-items-center">
                                                        <Col xs="auto">
                                                            <FotoFuncionarioAvatar
                                                                chapa={chapa}
                                                                nome={item.nome_func || item.NOME_FUNC || ""}
                                                                info01={`Chapa: ${chapa || ""}`}
                                                                info02={`ID: ${item.id_chamado || item.ID_CHAMADO} - ${formatarDataHora(item.ultimainteracao)}`}
                                                                onSelectFoto={setFotoSelecionada}
                                                                styleCustom={{ width: 56, height: 56, borderRadius: '50%', background: '#e9ecef', flexShrink: 0 }}
                                                            />
                                                        </Col>

                                                        <Col>
                                                            <Badge bg="secondary" className="mb-2">
                                                                #{item.id_chamado || item.ID_CHAMADO} - Loja: {item.loja}
                                                            </Badge>

                                                            <div className="fw-bold text-uppercase" style={{ fontSize: '0.9rem' }}>
                                                                {item.chapa} - {item.nome_func || item.NOME_FUNC || item.nome_candidato || item.NOME_CANDIDATO}
                                                            </div>

                                                            <div className="text-arbor fw-bold small mb-1">
                                                                {item.descricao_assunto || item.DESCRICAO_ASSUNTO}
                                                            </div>

                                                            <div
                                                                className="small text-muted text-truncate"
                                                                style={{ maxWidth: '100%' }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: decodeBase64(decodeBase64(item.pergunta_chamado || item.PERGUNTA_CHAMADO))
                                                                }}
                                                            />
                                                        </Col>

                                                        <div
                                                            className="text-end"
                                                            style={{
                                                                position: 'absolute', top: '15px', right: '20px',
                                                                width: '110px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end'
                                                            }}
                                                        >
                                                            <small className="d-block text-muted mb-2" style={{ fontSize: '0.7rem', whiteSpace: 'nowrap' }}>
                                                                {formatarDataHora(item.ultimainteracao)}
                                                            </small>

                                                            <Button
                                                                variant={(item.status_chamado ?? item.STATUS_CHAMADO) === 0 ? "danger" : "outline-secondary"}
                                                                size="sm"
                                                                className="fw-bold w-100"
                                                                style={{ fontSize: '0.75rem', padding: '4px 0' }}
                                                            >
                                                                {(item.status_chamado ?? item.STATUS_CHAMADO) === 0 ? "Atender" : "Visualizar"}
                                                            </Button>
                                                        </div>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        );
                                    })}
                                </div>
                            </>
                        )}

                    </Col>
                </Row>
            </Container>

            {/* MODAL DE CALENDÁRIO COM FOTO AMPLIÁVEL */}
            <Modal show={showModalCalendario} onHide={() => setShowModalCalendario(false)} size="lg" centered>
                <Modal.Header closeButton className="bg-arbor text-white">
                    <Modal.Title className="fs-6 fw-bold">
                        📅 Histórico de Humor do Colaborador
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {funcCalendario && (
                        <Card className="border-0 bg-light shadow-sm mb-3">
                            <Card.Body className="p-3">
                                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3">
                                    <div className="d-flex align-items-center gap-3">
                                        <FotoFuncionarioAvatar
                                            chapa={funcCalendario.chapa || funcCalendario.CHAPA}
                                            nome={funcCalendario.nome || funcCalendario.NOME || ""}
                                            info01={`Matrícula: ${funcCalendario.chapa || funcCalendario.CHAPA}`}
                                            info02={`Loja ${String(funcCalendario.codfilial || funcCalendario.CODFILIAL || '').padStart(2, '0')}`}
                                            onSelectFoto={setFotoSelecionada}
                                            styleCustom={{ width: 64, height: 64, borderRadius: '50%', background: '#fff', border: '2px solid #a81a1a', flexShrink: 0 }}
                                        />
                                        <div>
                                            <div className="d-flex align-items-center gap-2">
                                                <Badge bg="dark">Loja {String(funcCalendario.codfilial || funcCalendario.CODFILIAL || '').padStart(2, '0')}</Badge>
                                                <span className="text-muted small">Matrícula: <strong>{funcCalendario.chapa || funcCalendario.CHAPA}</strong></span>
                                            </div>
                                            <h5 className="fw-bold mb-0 text-uppercase mt-1 text-dark" style={{ fontSize: '1.05rem' }}>
                                                {funcCalendario.nome || funcCalendario.NOME}
                                            </h5>
                                            <div className="small text-secondary fw-semibold">
                                                {funcCalendario.funcao || funcCalendario.FUNCAO || '-'}
                                                {(funcCalendario.secao || funcCalendario.SECAO) ? ` (${funcCalendario.secao || funcCalendario.SECAO})` : ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center text-sm-end bg-white p-2 px-3 rounded border">
                                        <span className="x-small text-muted d-block fw-bold">MÉDIA NO PERÍODO</span>
                                        <div className="d-flex align-items-center gap-2 justify-content-center justify-content-sm-end">
                                            <span className="fs-3">{carinhasMap[Math.round(funcCalendario.media_func || funcCalendario.MEDIA_FUNC || 3)]?.emoji}</span>
                                            <span className="fs-4 fw-bold text-arbor">
                                                {Number(funcCalendario.media_func || funcCalendario.MEDIA_FUNC || 0).toFixed(1)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    )}

                    {loadingCalendario ? (
                        <div className="text-center py-5"><Spinner animation="border" className="text-arbor" /></div>
                    ) : (
                        <CalendarioReal
                            dados={dadosCalendario}
                            sentimentoEmEvidencia={sentimentoSelecionado !== '0' ? sentimentoSelecionado : null}
                            dataInicio={filtroDataIniHumor}
                            dataFim={filtroDataFimHumor}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowModalCalendario(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalVaga} onHide={() => setShowModalVaga(false)} size="xl" centered id="modal-solicitacao-vaga">
                <Modal.Header closeButton className="bg-light py-2">
                    <Modal.Title className="fs-6 fw-bold text-secondary">
                        Solicitação de Vaga número: ***** {selectedVaga?.pedido} *****
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {selectedVaga && (
                        <div className="d-flex flex-column gap-3">
                            <Card className="border p-3 bg-light">
                                <Row className="g-3">
                                    <Col md={2}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">TIPO</Form.Label>
                                        <Form.Control size="sm" readOnly value={selectedVaga.tipo || selectedVaga.TIPO || 'NOVA'} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">STATUS</Form.Label>
                                        <Form.Control size="sm" readOnly value={statusVagasMap[selectedVaga.status]?.label || selectedVaga.nomestatus || ''} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">DATA SOLICITAÇÃO</Form.Label>
                                        <Form.Control size="sm" readOnly value={formatarDataHora(selectedVaga.datapedido).split(',')[0]} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">SOLICITANTE</Form.Label>
                                        <Form.Control size="sm" readOnly value={selectedVaga.solicitante || '-'} />
                                    </Col>

                                    <Col md={2}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">CÓDIGO DA SEÇÃO</Form.Label>
                                        <Form.Control size="sm" readOnly value={selectedVaga.setor || ''} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">SEÇÃO</Form.Label>
                                        <Form.Control size="sm" readOnly value={selectedVaga.secao || selectedVaga.setor_nome || ''} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">FUNÇÃO</Form.Label>
                                        <Form.Control size="sm" readOnly value={selectedVaga.funcao || ''} />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">SALÁRIO (R$)</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            value={formSalarioVaga}
                                            onChange={handleSalarioChange}
                                        />
                                    </Col>

                                    <Col md={6}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">MOTIVO</Form.Label>
                                        <Form.Control as="textarea" rows={2} size="sm" readOnly value={selectedVaga.motivo || ''} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">REQUISITOS</Form.Label>
                                        <Form.Control as="textarea" rows={2} size="sm" readOnly value={selectedVaga.requisitos || ''} />
                                    </Col>

                                    <Col md={2}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">CÓDIGO HORÁRIO</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            value={formHorarioVaga}
                                            onChange={(e) => setFormHorarioVaga(e.target.value)}
                                            onBlur={(e) => consultarHorario(e.target.value)}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">DESCRIÇÃO DO HORÁRIO</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            readOnly
                                            value={loadingHorario ? "Buscando..." : (descHorarioVaga || 'Informe o código')}
                                            className="bg-white text-arbor fw-bold"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">INDICADO/CANDIDATO</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            value={formCandidatoVaga}
                                            onChange={(e) => setFormCandidatoVaga(e.target.value)}
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <Form.Label className="text-muted x-small fw-bold mb-1">ÚLTIMO A FAZER ALTERAÇÃO NO STATUS</Form.Label>
                                        <Form.Control size="sm" readOnly value={selectedVaga.funcrh || selectedVaga.FUNCRH || '-'} />
                                    </Col>
                                </Row>
                            </Card>

                            <Card className="border p-2 bg-light">
                                <fieldset className="border p-2 rounded">
                                    <legend className="float-none w-auto px-2 fs-7 fw-bold text-secondary mb-1">Quadro</legend>
                                    <Row className="g-2 text-center align-items-center">

                                        <Col md={5}>
                                            <fieldset className="border p-2 rounded bg-white">
                                                <legend className="float-none w-auto px-1 x-small fw-bold text-dark mb-1">
                                                    Resultado da loja {selectedVaga.loja || selectedVaga.CODLINHA || '03'}
                                                </legend>
                                                <Row className="g-1 align-items-end">
                                                    <Col md={4}>
                                                        <div className="x-small fw-bold text-muted mb-1 text-nowrap d-flex align-items-center justify-content-center" style={{ minHeight: '22px' }}>
                                                            QUADRO
                                                        </div>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-funcionario" value={selectedVaga.quadro_loja || 39} />
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-parttime" value={selectedVaga.quadro_loja_pt || 1} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="x-small fw-bold text-muted mb-1 text-nowrap d-flex align-items-center justify-content-center" style={{ minHeight: '22px', fontSize: '0.65rem' }}>
                                                            FUNCIONÁRIOS
                                                        </div>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-funcionario" value={selectedVaga.funcs_loja || 31} />
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-parttime" value={selectedVaga.funcs_loja_pt || 4} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="x-small fw-bold text-muted mb-1 text-nowrap d-flex align-items-center justify-content-center" style={{ minHeight: '22px' }}>
                                                            PENDÊNCIAS
                                                        </div>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Form.Control size="sm" readOnly className="text-center px-1 text-danger fw-bold campo-funcionario" value={selectedVaga.pend_loja || 17} />
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-parttime" value={selectedVaga.pend_loja_pt || 0} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </fieldset>
                                        </Col>

                                        <Col md={2} className="d-flex flex-column align-items-center justify-content-center">
                                            <span className="fw-bold fs-7 mb-1 text-secondary">Legenda</span>
                                            <div className="border rounded p-1 w-100 x-small fw-bold text-muted mb-1 text-nowrap text-center legenda-funcionario" style={{ fontSize: '0.65rem' }}>
                                                FUNCIONÁRIOS
                                            </div>
                                            <div className="border rounded p-1 w-100 x-small fw-bold text-muted text-nowrap text-center legenda-parttime" style={{ fontSize: '0.65rem' }}>
                                                PART-TIME
                                            </div>
                                        </Col>

                                        <Col md={5}>
                                            <fieldset className="border p-2 rounded bg-white">
                                                <legend className="float-none w-auto px-1 x-small fw-bold text-dark mb-1">
                                                    Seção: {selectedVaga.setor || '003.03.05'} - {selectedVaga.secao || selectedVaga.setor_nome || 'HORTIFRUTI'}
                                                </legend>
                                                <Row className="g-1 align-items-end">
                                                    <Col md={4}>
                                                        <div className="x-small fw-bold text-muted mb-1 text-nowrap d-flex align-items-center justify-content-center" style={{ minHeight: '22px' }}>
                                                            QUADRO
                                                        </div>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-funcionario" value={selectedVaga.quadro_secao || 6} />
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-parttime" value={selectedVaga.quadro_secao_pt || 0} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="x-small fw-bold text-muted mb-1 text-nowrap d-flex align-items-center justify-content-center" style={{ minHeight: '22px', fontSize: '0.65rem' }}>
                                                            FUNCIONÁRIOS
                                                        </div>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-funcionario" value={selectedVaga.funcs_secao || 1} />
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-parttime" value={selectedVaga.funcs_secao_pt || 0} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="x-small fw-bold text-muted mb-1 text-nowrap d-flex align-items-center justify-content-center" style={{ minHeight: '22px' }}>
                                                            PENDÊNCIAS
                                                        </div>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Form.Control size="sm" readOnly className="text-center px-1 text-danger fw-bold campo-funcionario" value={selectedVaga.pend_secao || 1} />
                                                            <Form.Control size="sm" readOnly className="text-center px-1 campo-parttime" value={selectedVaga.pend_secao_pt || 0} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </fieldset>
                                        </Col>

                                    </Row>
                                </fieldset>
                            </Card>

                            {(selectedVaga.substituido || selectedVaga.matriculaant) && (
                                <Card className="border p-3 bg-light">
                                    <h6 className="fw-bold fs-7 text-secondary mb-2">Substituído</h6>
                                    <Row className="g-2">
                                        <Col md={2}>
                                            <Form.Label className="text-muted x-small mb-1">Matrícula</Form.Label>
                                            <Form.Control size="sm" readOnly value={selectedVaga.matriculaant || '-'} />
                                        </Col>
                                        <Col md={5}>
                                            <Form.Label className="text-muted x-small mb-1">Nome</Form.Label>
                                            <Form.Control size="sm" readOnly value={selectedVaga.substituido || '-'} />
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label className="text-muted x-small mb-1">Função</Form.Label>
                                            <Form.Control size="sm" readOnly value={selectedVaga.funcao || '-'} />
                                        </Col>
                                        <Col md={2}>
                                            <Form.Label className="text-muted x-small mb-1">Admissão</Form.Label>
                                            <Form.Control size="sm" readOnly value={selectedVaga.dataadmissaoant || '-'} />
                                        </Col>
                                    </Row>
                                </Card>
                            )}

                            <div className="rodape-impressao d-flex justify-content-between align-items-end mt-2 pt-2">
                                <img src={logoSmall} alt="Arbor Web" style={{ height: '38px', objectFit: 'contain' }} />
                                <img src={logoF2} alt="F2" style={{ height: '32px', objectFit: 'contain' }} />
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between no-print">
                    <div className="d-flex gap-2">
                        <Button variant="secondary" size="sm" onClick={() => setShowModalVaga(false)}>Fechar</Button>
                        <Button variant="outline-dark" size="sm" onClick={handleImprimirModal}>
                            <i className="bi bi-printer me-1"></i> Imprimir
                        </Button>
                    </div>

                    <div className="d-flex gap-2">
                        {selectedVaga?.status === 0 && (
                            <Button variant="warning" size="sm" onClick={() => ExecutarAcaoStatusVaga(1)}>Providenciar Candidato</Button>
                        )}
                        {selectedVaga?.status === 1 && (
                            <Button variant="info" size="sm" onClick={() => ExecutarAcaoStatusVaga(2)}>Aguardar Aprovação</Button>
                        )}
                        {selectedVaga?.status === 2 && (
                            <Button className="btn-arbor" size="sm" onClick={() => ExecutarAcaoStatusVaga(3)}>Aprovar Candidato</Button>
                        )}
                        {selectedVaga?.status === 3 && (
                            <Button variant="dark" size="sm" onClick={() => ExecutarAcaoStatusVaga(4)}>Documentos Providenciados</Button>
                        )}
                        {selectedVaga?.status === 4 && (
                            <Button variant="success" size="sm" onClick={() => ExecutarAcaoStatusVaga(5)}>Aprovar Exames</Button>
                        )}
                        {selectedVaga?.status === 5 && (
                            <Button variant="success" size="sm" onClick={() => ExecutarAcaoStatusVaga(10)}>Finalizar Admissão</Button>
                        )}

                        {(selectedVaga?.status >= 4 && selectedVaga?.status <= 5) && (
                            <Button variant="danger" size="sm" onClick={() => setShowModalAcaoVaga(true)}>Desistência / Reprovado</Button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalAcaoVaga} onHide={() => setShowModalAcaoVaga(false)} centered>
                <Modal.Header closeButton className="bg-danger text-white">
                    <Modal.Title className="fs-6">Desistência ou Reprovação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold small">Classificação:</Form.Label>
                        <div>
                            <Form.Check inline type="radio" label="Desistência" name="subtipo" checked={subTipoCancelamento === 'Desistência'} onChange={() => setSubTipoCancelamento('Desistência')} />
                            <Form.Check inline type="radio" label="Reprovado" name="subtipo" checked={subTipoCancelamento === 'Reprovado'} onChange={() => setSubTipoCancelamento('Reprovado')} />
                        </div>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label className="fw-bold small">Descreva o Motivo:</Form.Label>
                        <Form.Control as="textarea" rows={3} value={formMotivoCancelamento} onChange={(e) => setFormMotivoCancelamento(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowModalAcaoVaga(false)}>Cancelar</Button>
                    <Button variant="danger" size="sm" onClick={handleDesistenciaOuReprovacaoVaga}>Confirmar e Substituir</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalAvaliar} onHide={() => setShowModalAvaliar(false)} size="xl" centered scrollable>
                <Modal.Header closeButton className="bg-dark text-white p-2 px-3">
                    <Modal.Title className="fs-6">Dossiê do Candidato: {selectedCur?.nome_candidato}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Row className="g-0">
                        <Col md={7} className="p-4 border-end bg-light">
                            <h6 className="fw-bold text-arbor border-bottom pb-2 mb-3">Dados Pessoais</h6>
                            <Row className="gy-3">
                                <Col md={12}><label className="fw-bold text-muted d-block small">{selectedCur?.nome_candidato}</label></Col>
                                <Col md={6}><label className="fw-bold text-muted d-block small">✉️ Email</label><span className="small">{selectedCur?.email_candidato}</span></Col>
                                <Col md={6}><label className="fw-bold text-muted d-block small">📱 Telefone</label><span className="small">{selectedCur?.telefone_candidato}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">🎂 Nasc:</label><span className="small">{selectedCur?.dta_nascimento ? new Date(selectedCur.dta_nascimento).toLocaleDateString() : '-'}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">💍 Civil:</label><span className="small">{selectedCur?.estado_civil}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">🧒🏻 Filhos:</label><span className="small">{selectedCur?.tem_filhos}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">🎓 Escolaridade</label><span className="small">{selectedCur?.escolaridade}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">🪪 CNH</label><span className="small">{selectedCur?.cnh_categoria || 'Não possui'}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">🧬 Etnia:</label><span className="small">{selectedCur?.etnia_ibge}</span></Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small"> Gênero:</label><span className="small">{selectedCur?.genero_identidade}</span></Col>
                                <Col md={4}>
                                    <label className="fw-bold text-muted d-block small">🔗 Linkedin:</label>
                                    <a href={selectedCur?.link_linkedin} className="dropdown-item" target="_blank" rel="noopener noreferrer">
                                        {selectedCur?.link_linkedin ? selectedCur.link_linkedin.split('/in/')[1]?.replace(/\/$/, '') : ''}
                                    </a>
                                </Col>
                                <Col md={4}><label className="fw-bold text-muted d-block small">👫🏻 Familiar:</label><span className="small">{selectedCur?.familiar_floresta}</span></Col>
                                <Col md={12}><label className="fw-bold text-muted d-block small">🏠 Endereço Completo</label><span className="small">{selectedCur?.endereco_completo}</span></Col>
                                <Col md={6}><label className="fw-bold text-muted d-block small">🏪 Loja Preferência</label><Badge bg="info">{selectedCur?.loja_preferencia}</Badge></Col>
                                <Col md={6}><label className="fw-bold text-muted d-block small">💰 Pretensão Salarial</label><span className="fw-bold text-success small">R$ {Number(selectedCur?.valor_pretensao).toLocaleString()}</span></Col>
                                <Col md={12}><label className="fw-bold text-muted d-block small">🗓️ Última Alteração</label><span className="small">{selectedCur?.dta_alteracao ? new Date(selectedCur.dta_alteracao).toLocaleString() : '-'}</span></Col>
                                <Col md={12}><label className="fw-bold text-muted d-block small">🧾 Áreas de Interesse</label><span className="small">{selectedCur?.areas_descricoes}</span></Col>
                            </Row>
                            <hr />
                            <h6 className="fw-bold text-arbor mb-2">Apresentação</h6>
                            <div className="p-3 border rounded bg-white overflow-auto mb-3" style={{ maxHeight: '200px' }}
                                dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(selectedCur?.texto_apresentacao)) }} />
                            <Button variant="danger" className="w-100" onClick={() => handleBuscarEVerCurriculo(selectedCur?.email_candidato, selectedCur?.nome_arquivo)}>
                                Curriculo Enviado
                            </Button>
                        </Col>
                        <Col md={5} className="p-4 bg-white">
                            <h6 className="fw-bold text-success border-bottom pb-2 mb-4">Avaliação do RH</h6>
                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">Classificação (Nota)</Form.Label>
                                <div className="d-flex justify-content-between">
                                    {[1, 2, 3, 4, 5].map(n => (
                                        <Button key={n} variant={avaliacao.nota === n ? "danger" : "outline-secondary"} onClick={() => setAvaliacao({ ...avaliacao, nota: n })}>{n}</Button>
                                    ))}
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Já foi entrevistado?</Form.Label>
                                <Form.Select size="sm" value={avaliacao.entrevistado} onChange={e => setAvaliacao({ ...avaliacao, entrevistado: e.target.value })}>
                                    <option value="N">Não</option><option value="S">Sim</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Observações Internas</Form.Label>
                                <Form.Control as="textarea" rows={6} value={decodeBase64(decodeBase64(avaliacao.obs))} onChange={e => setAvaliacao({ ...avaliacao, obs: e.target.value })} placeholder="Descreva aqui o parecer..." />
                            </Form.Group>
                            <Button variant="success" className="w-100 mt-2 shadow-sm" onClick={handleSalvarAvaliacao}>Gravar Avaliação</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal show={showModalFaq} onHide={() => setShowModalFaq(false)} size="lg" centered scrollable>
                <Modal.Header closeButton className="bg-arbor text-white">
                    <Modal.Title className="fs-6 fw-bold">Gestão de Conteúdo FAQ</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '75vh' }}>
                    <Row>
                        <Col md={5} className="border-end">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="fw-bold small">1. Selecione ou crie</span>
                                <Button variant="success" size="sm" style={{ fontSize: '10px' }} onClick={prepararNovaFaq}>+ NOVO ASSUNTO</Button>
                            </div>
                            <InputGroup size="sm" className="mb-2">
                                <Form.Control placeholder="Pesquisar..." value={buscaFaq} onChange={(e) => setBuscaFaq(e.target.value)} />
                            </InputGroup>
                            <ListGroup variant="flush" className="border rounded overflow-auto" style={{ maxHeight: '400px' }}>
                                {faqsFiltradas.map(a => {
                                    const idItem = Number(a.id_assunto ?? a.ID_ASSUNTO);
                                    const isSelected = modoFaq === "edicao" && faqId === idItem;
                                    return (
                                        <ListGroup.Item key={idItem} action className={`small py-2 ${isSelected ? 'active' : ''}`} onClick={() => selecionarParaEditar(a)} style={{ cursor: 'pointer' }}>
                                            {a.descricao_assunto || a.DESCRICAO_ASSUNTO}
                                            {(a.texto_faq_assunto || a.TEXTO_FAQ_ASSUNTO) &&
                                                <Badge bg={isSelected ? "light" : "success"} text={isSelected ? "dark" : "white"} className="ms-1" pill style={{ fontSize: '8px' }}>FAQ</Badge>
                                            }
                                        </ListGroup.Item>
                                    );
                                })}
                            </ListGroup>
                        </Col>
                        <Col md={7} key={faqId}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <Form.Label className="fw-bold small mb-0 text-arbor">{modoFaq === "novo" ? "2. Cadastrar Nova FAQ" : "2. Editar FAQ Selecionada"}</Form.Label>
                                <Form.Check type="switch" id="switch-ativo" label={faqAtivo === "S" ? "Ativa" : "Inativa"} className={`small fw-bold ${faqAtivo === "S" ? "text-success" : "text-danger"}`} checked={faqAtivo === "S"} onChange={(e) => setFaqAtivo(e.target.checked ? "S" : "N")} />
                            </div>
                            <Form.Group className="mb-2">
                                <Form.Label className="x-small text-muted mb-0">Título do Assunto</Form.Label>
                                <Form.Control ref={tituloRef} size="sm" type="text" defaultValue={faqPergunta} onChange={(e) => setFaqPergunta(e.target.value)} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className="x-small text-muted mb-0">Resposta (Editor)</Form.Label>
                                <div className="quill-editor-container">
                                    <ReactQuill theme="snow" value={faqResposta} onChange={setFaqResposta} />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" size="sm" onClick={() => setShowModalFaq(false)}>Fechar</Button>
                    <Button className={modoFaq === "novo" ? "btn-arbor" : "btn-success"} size="sm" onClick={handleSalvarFaqDireto}>{modoFaq === "novo" ? "Criar FAQ" : "Salvar Alterações"}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showResponder} onHide={() => setShowResponder(false)} size="lg" centered scrollable>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fs-6 fw-bold">
                        {podeResponder ? "Atendimento" : "Consulta"} #{selected?.id_chamado || selected?.ID_CHAMADO}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="bg-chat-rh">
                    <div className="mb-4">
                        <h6 className="fw-bold border-bottom pb-2 small">Histórico de Mensagens</h6>
                        {loadingChat ? (
                            <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>
                        ) : (
                            mensagens.map((m, idx) => {
                                return (
                                    <div key={idx} className={`mb-3 p-3 rounded shadow-sm ${m.tipo_autor === 'U' ? 'bg-white border-start border-4 border-info' : 'bg-light border-start border-4 border-danger'}`}>
                                        <div className="d-flex justify-content-between mb-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <FotoFuncionarioAvatar
                                                    chapa={m.matricula}
                                                    nome={m.nome || "Usuário"}
                                                    info01={`Matrícula: ${m.matricula}`}
                                                    info02={formatarDataHora(m.datahora_interacao)}
                                                    onSelectFoto={setFotoSelecionada}
                                                    styleCustom={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }}
                                                />
                                                <small className="fw-bold">
                                                    {m.tipo_autor === 'U' ? (m.nome || 'INTERESSADO') : `RH: ${m.nome || nomeRHLogado}`}
                                                </small>
                                            </div>
                                            <small className="text-muted" style={{ fontSize: '10px' }}>{formatarDataHora(m.datahora_interacao)}</small>
                                        </div>
                                        <div className="small text-break" dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(m.mensagem)) }} />

                                        {m.anexo_nome && (
                                            <div className="mt-2 border-top pt-1">
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    className="p-0 text-decoration-none fw-bold text-arbor"
                                                    onClick={() => handleBuscarEVerArquivoChamado(
                                                        selected?.id_chamado || selected?.ID_CHAMADO,
                                                        m.id_interacao || m.ID_INTERACAO,
                                                        m.anexo_nome
                                                    )}
                                                >
                                                    📎 {m.anexo_nome}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        )}
                    </div>

                    {podeResponder && (
                        <div className="mt-3 border-top pt-3">
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-bold small text-arbor">Sua Resposta:</Form.Label>
                                <div className="quill-editor-container">
                                    <ReactQuill theme="snow" value={respostaHtml} onChange={setRespostaHtml} />
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className="x-small">Anexar Arquivo</Form.Label>
                                <Form.Control type="file" size="sm" onChange={(e) => setArquivoRH(e.target.files[0])} />
                            </Form.Group>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowResponder(false)}>Fechar</Button>
                    {podeResponder && (
                        <Button className="btn-arbor" size="sm" onClick={handleEnviarResposta} disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm" /> : "Enviar Resposta"}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fs-6 fw-bold">{previewNome}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: "60vh" }}>
                    {previewTipo === "application/pdf" && (
                        <iframe src={previewUrl} title="Preview PDF" style={{ width: "100%", height: "70vh", border: "none" }} />
                    )}
                    {(previewTipo === "image/png" || previewTipo === "image/jpeg" || previewTipo === "image/jpg") && (
                        <img src={previewUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: "70vh", display: "block", margin: "0 auto" }} />
                    )}
                    {!previewTipo.startsWith("image/") && previewTipo !== "application/pdf" && (
                        <div className="text-center">
                            <p className="mb-3">Não é possível exibir este tipo de arquivo.</p>
                            <Button className="btn-arbor" onClick={() => {
                                const link = document.createElement("a");
                                link.href = previewUrl;
                                link.download = previewNome;
                                link.click();
                            }}>Baixar arquivo</Button>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPreview(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            <Footer />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.info01}
                info02={fotoSelecionada?.info02}
            />
        </div>
    );
}

export default DashboardRH;